import { Route, Routes } from 'react-router-dom';
import Home from './pages/Home';
import Journey from './pages/Journey';
import ViewerTest from './pages/ViewerTest';

export default function App() {
  return (
    <Routes>
      <Route path="/" element={<Home />} />
      <Route path="/__viewer-test" element={<ViewerTest />} />
      <Route path="/j/:id" element={<Journey />} />
    </Routes>
  );
}
